import { fetchApi } from "../dataAccess";
import { ElementQuery } from "types/form/ElementQuery";

const getEcrfElementQueryPath = (ecrfId: string, elementId: string) =>
  `/api/ecrves/${ecrfId}/${elementId}/qd`;

export const getEcrfElementQuery = (ecrfId: string, elementId: string) =>
  async () => await fetchApi<ElementQuery>(getEcrfElementQueryPath(ecrfId, elementId), { cache: "no-cache" });

export default { getEcrfElementQuery, getEcrfElementQueryPath };